import { render, staticRenderFns } from "./image_slider.vue?vue&type=template&id=068ace61&"
import script from "./image_slider.vue?vue&type=script&lang=js&"
export * from "./image_slider.vue?vue&type=script&lang=js&"
import style0 from "./image_slider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports